import { bindable } from 'aurelia-framework';

class OdsDropdown {
  @bindable itemsIdProperty = 'id';
  @bindable itemsLabelProperty = 'label';
  @bindable label = '';
  @bindable placeholder = '';
  @bindable prefix = '';
  @bindable type = '';
  @bindable disabled = false;
  @bindable error = '';
  @bindable items = [];
  @bindable selectedItem = null;
  @bindable onItemSelected = () => {};
  constructor() {
    this.open = false;
  }
  itemSelectedChange(item) {
    this.open = false;
    this.error = false;
    this.onItemSelected({ item });
  }
  onKeyup($event) {
    const enterKey = 13;
    if ($event.keyCode === enterKey) {
      this.toggleDropdown();
    }
  }
  toggleDropdown() {
    this.open = !this.open;
  }
}

export { OdsDropdown };
